module.exports = __webpack_public_path__ + "img/mapa-mundo.d68c58f0.png";